import { Modal } from "antd";
import React from "react";

/* ================= PRIVACY POLICY COMPONENT ================= */
export const PrivacyPolicy = ({ open, onClose }) => {
  return (
    <>
      <Modal
        title="Privacy Policy"
        closable={true}
        open={open}
        onCancel={onClose}
        onOk={onClose}
        footer={null}
        width={920}
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="p-6 md:p-10 max-w-4xl mx-auto text-gray-900 leading-relaxed">
          {/* <h1 className="text-4xl font-extrabold mb-6">Privacy Policy</h1> */}
          <p className="mb-4">
            <strong>Effective date:</strong> 13/11/25
          </p>

          <p className="mb-6 italic text-gray-700">
            Quelld – Privacy Policy and Terms of Use (Working draft). This
            Privacy Policy applies to Quelld.ai, Quelld.com, and all related
            services and communications. Replace placeholders and seek legal
            review before publication.
          </p>

          {/* Who we are */}
          <h2 className="text-2xl font-bold mt-8 mb-3">Who We Are</h2>
          <p>
            Quelld is a trading name of <strong>Quelld Ltd</strong> registered
            in England & Wales, company number <strong>16873813</strong>.
            Registered office: 128 City Road, London, EC1V 2NX. Contact:{" "}
            <strong>operations@quelld.com</strong>. For Data Protection matters
            (if a DPO is appointed): <strong>privacy@quelld.com</strong>.
          </p>

          {/* What the policy covers */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            What This Policy Covers
          </h2>
          <ul className="list-disc pl-6 space-y-1 mb-3">
            <li>
              <strong>Quelld.ai</strong> — AI-enabled features to help
              co-parents/families manage schedules, communication, and tasks.
            </li>
            <li>
              <strong>Quelld.com</strong> — marketing site and service bookings
              via Trafft (white label).
            </li>
            <li>
              Any related communication channels including email, messaging, and
              support.
            </li>
          </ul>
          <p>
            Quelld acts as a <strong>Controller</strong> of your personal data
            under UK GDPR, the Data Protection Act 2018, and (where applicable)
            EU GDPR.
          </p>

          {/* 1) Personal data we collect */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            1) Personal Data We Collect
          </h2>

          <h3 className="text-xl font-semibold mt-4 mb-2">You Provide:</h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Account & SSO data: name, email, password/SSO token, role, photo,
              contact details, address/postcode (optional), preferences.
            </li>
            <li>
              Co‑parenting & household data: calendars, events, custody patterns
              (e.g., 5‑2‑2‑5), notes, tasks, and optional child first names and
              ages.
            </li>
            <li>
              Booking data: services offered or sought, pricing, availability,
              reviews.
            </li>
            <li>Communications: messages between users or support.</li>
            <li>
              Payment data: limited billing metadata (never full card numbers).
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-2">
            Collected Automatically:
          </h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              IP address, device identifiers, OS, browser/app type, time zone.
            </li>
            <li>Crash logs, screen views, clicks, referring URLs.</li>
            <li>
              Cookies and similar tech for sign‑in, security, analytics, A/B
              testing, marketing.
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-6 mb-2">
            From Third Parties:
          </h3>
          <ul className="list-disc pl-6 space-y-1">
            <li>Trafft (bookings)</li>
            <li>Payment processors</li>
            <li>Analytics and advertising partners</li>
            <li>AI/ML vendors processing user‑authorised content</li>
          </ul>

          {/* 2) Special notes on children */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            2) Special Notes About Children
          </h2>
          <p>
            Quelld is intended for adults (18+). Parents/guardians may input
            limited information about children solely to manage schedules. Do{" "}
            <strong>not</strong> upload unnecessary or sensitive data about
            children. If we learn that we collected a child’s data without
            proper authorisation, we will delete it.
          </p>

          {/* 3) How we use your data */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            3) How We Use Your Data (Lawful Bases)
          </h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Provide & secure the App/Site (contract)</li>
            <li>Bookings & marketplace features (contract)</li>
            <li>AI-enabled features (contract/legitimate interests/consent)</li>
            <li>Payments & compliance (contract/legal obligation)</li>
            <li>Communications (legitimate interests/consent)</li>
            <li>Analytics & product improvement (legitimate interests)</li>
            <li>Legal compliance (legal obligation)</li>
          </ul>

          {/* 4) Sharing */}
          <h2 className="text-2xl font-bold mt-8 mb-3">4) Sharing Your Data</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              Vendors & processors (Trafft, hosting, analytics, email, payments,
              AI)
            </li>
            <li>
              Other users during interactions (messages, bookings, profiles)
            </li>
            <li>Authorities when required by law</li>
            <li>Business transfers (merger/acquisition)</li>
          </ul>

          {/* 5) International transfers */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            5) International Transfers
          </h2>
          <p>
            We use safeguards such as the UK IDTA and EU Standard Contractual
            Clauses (SCCs) for transfers outside the UK/EEA.
          </p>

          {/* 6) Data retention */}
          <h2 className="text-2xl font-bold mt-8 mb-3">6) Data Retention</h2>
          <p>
            Personal data is retained only as long as needed for service
            provision and legal requirements. For example, booking and
            transaction records are stored for at least 6 years (UK tax law).
            You may request deletion, but some data must be retained.
          </p>

          {/* 7) Your rights */}
          <h2 className="text-2xl font-bold mt-8 mb-3">7) Your Rights</h2>
          <p className="mb-2">You may request:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Access, correction, deletion</li>
            <li>Restriction or objection (including marketing)</li>
            <li>Data portability</li>
            <li>Withdrawal of consent where applicable</li>
          </ul>
          <p className="mt-3">
            Contact: <strong>privacy@quelld.com</strong>. You may also complain
            to the UK Information Commissioner’s Office (ICO).
          </p>

          {/* 8) Security */}
          <h2 className="text-2xl font-bold mt-8 mb-3">8) Security</h2>
          <p>
            We use encryption, salted password hashing, access controls, and
            vendor due diligence. No system is perfectly secure — keep your
            credentials safe and enable MFA.
          </p>

          {/* 9) Automated decision making */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            9) Automated Decision‑Making
          </h2>
          <p>
            Automated features may classify connected emails, detect keywords,
            or suggest scheduling. These are assistive only and can usually be
            disabled in settings.
          </p>

          {/* 10) Cookies */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            10) Cookies & Similar Technologies
          </h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Strictly necessary: sign‑in, SSO, security</li>
            <li>Preferences: store roles & settings</li>
            <li>Analytics: improve features</li>
            <li>Marketing: measure performance (with consent)</li>
          </ul>
          <p className="mt-3">
            Manage preferences in our cookie banner or your browser settings.
          </p>

          {/* 11) Contact & updates */}
          <h2 className="text-2xl font-bold mt-8 mb-3">
            11) Contact & Updates
          </h2>
          <p>
            We may update this policy when laws or services change. Updates will
            be posted with the revised date. Material changes will be notified
            via email or in‑app.
          </p>
        </div>
      </Modal>
    </>
  );
};
